export default __webpack_public_path__ + "static/fortuneTellingMan-5d86e2f41acae8b367030b711a9cb615.png";